import { saveAs } from 'file-saver';
import { parseAsync } from 'json2csv';

interface ExportToCSVProps {
  filename: string;
  data: Record<string, any>[];
  headers: string[];
}

export const exportToCSV = async ({ filename, data, headers }: ExportToCSVProps) => {
  const csvContent = await parseAsync<Record<string, any>[]>(data, {
    fields: headers,
  });
  const blob = new Blob([csvContent], { type: `text/csv;charset=utf-8;` });
  saveAs(blob, `${filename}.csv`);
};

export default {};
